import cx from 'classnames';
import useTranslation from 'next-translate/useTranslation';
import { useFormContext } from 'react-hook-form';

import Button from '../../../button';
import IconSearch from '../../../icons/search';
import Sticky from 'react-sticky-el';
import useIsMobile from '../../../../../hooks/use-is-mobile';
import { useEffect, useRef, useState } from 'react';
import TextInput from '../../../v2/inputs/text';
import { useRouter } from 'next/router';

type DesktopReferenceProps = {
  border?: boolean;
  sideBorder?: boolean;
  mainProps: any;
};

const DesktopReference = (
  {
    border = true,
    mainProps,
    sideBorder = false,
    ref
  }: DesktopReferenceProps
) => {
  const { events: routerEvents, query } = useRouter();
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { watch, setValue } = useFormContext();
  const value = watch('reference');

  const refInput = useRef(null);
  const innerRef = ref || refInput;
  const [refi, setValues] = useState(value || '');

  useEffect(() => {
    if (routerEvents) {
      setValues(value);
    }
  }, [routerEvents, value, query]);

  return isMobile ? (
    <div className={cx('flex items-end group', mainProps)}>
      <div className={cx('w-full', { 'pr-[1px]': sideBorder })}>
        <TextInput
          ref={innerRef}
          label={t('product:reference')}
          placeholder="Exemplo: 9hz, 2321312321"
          border={border}
          clearButton
          onClear={() => {
            setValues('');
          }}
          value={refi}
          onChange={(e) => {
            setValue('reference', e.target.value);
          }}
          focusBg
          labelBehaviour={'animated'}
        />
      </div>
      <Button
        isFullWidth={false}
        className={cx('w-12 ', {
          'border-b border-b-neutral-80 group-focus-within:border-b-brand-100 group-focus:border-b-brand-100 group-focus-within:bg-brand-100':
            border,
        })}
        onClick={() => setValue('reference', refi)}
      >
        <IconSearch className="w-4 h-4 text-neutral-80 group-focus-within:text-white" />
      </Button>
    </div>
  ) : (
    <>
      <div className="flex items-end group pt-6">
        <TextInput
          ref={innerRef}
          label={t('product:reference')}
          placeholder="Exemplo: 9hz, 2321312321"
          border={border}
          clearButton
          onClear={() => {
            setValues('');
          }}
          value={refi}
          onChange={(e) => {
            setValue('reference', e.target.value);
          }}
          focusBg
        />
        <Button
          isFullWidth={false}
          className="w-12 border-b border-b-neutral-80 group-focus-within:border-b-brand-100 group-focus-within:bg-brand-100"
          onClick={() => setValue('reference', refi)}
        >
          <IconSearch className="text-neutral-80 group-focus-within:text-white" />
        </Button>
      </div>
      {/*    <Sticky
      mode="top"
      boundaryElement=".hybridSavedCarTitle"
      hideOnBoundaryHit={true}
      wrapperClassName="pt-6 border-r border-r-white"
      stickyClassName={cx('z-10 bg-white !pb-4')}
    >
      
    </Sticky>*/}
    </>
  );
};

DesktopReference.displayName = 'DesktopReference';
export default DesktopReference;
